// React
import React, { useState } from "react";

// Libraries
import PropTypes from "prop-types";
import { Map, Marker } from "pigeon-maps";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const TextContent = ({ item }) => {
	const location = [item?.uri?.latitude, item?.uri?.longitude];
	const [center, setCenter] = useState(location);

	const handleClick = () => {
		window.open(`https://www.google.com/maps/search/?api=1&query=${item?.uri?.latitude},${item?.uri?.longitude}`, "_blank");
	};

	const onBoundsChanged = () => {
		setCenter(location);
	};

	return (
		<div className={styles.container}>
			<Map center={center} zoom={16} minZoom={16} maxZoom={16} touchEvents={false} onClick={handleClick} onBoundsChanged={onBoundsChanged}>
				<Marker width={40} anchor={center} color="red" />
			</Map>
			<Text className={styles.text} withMarkdown>
				{item.text}
			</Text>
		</div>
	);
};

TextContent.propTypes = {
	item: PropTypes.object,
};

export default TextContent;
